import intl from 'react-intl-universal'

export default [NoAccessController]

export function NoAccessController() {
  this.intl = intl
}
